// src/apps/liff/pages/nps-page/components/WelcomePage.jsx
import { Center, Text, Button, Stack, Image } from "@mantine/core";
import ErrorModal from "./ErrorModal";

export default function WelcomePage({
	onStart,
	memberData,
	errorMessage,
	errorMessageDescription,
}) {
	if (!memberData) {
		return (
			<ErrorModal
				opened={true}
				errorMessage={errorMessage}
				errorMessageDescription={errorMessageDescription}
			/>
		);
	}
	return (
		<Stack
			px="8.14vw"
			pt="24.42vw"
			pb="11.63vw"
			align="center"
			justify="space-between"
			h="100vh"
		>
			<Image
				src={window.assetUrl("/images/liff/questionnaire-page/logo.png")}
				alt="Tory Burch"
				w="58%"
			/>

			<Center>
				<Text align="center" size="3.76vw" lh="1.4">
					感謝光臨 {memberData.survey.store.display_name}
					<br />
					誠摯邀請您參與此份體驗調查，僅須兩分鐘即可完
					<br />
					成，我們期待您的寶貴回饋。
				</Text>
			</Center>

			<Stack w="100%">
				<Button
					fullWidth
					radius="xl"
					size="lg"
					color="black"
					style={{
						border: "2px solid #DDDDDD",
					}}
					onClick={onStart}
				>
					開始填寫
				</Button>
				<Button
					fullWidth
					variant="transparent"
					radius="xl"
					size="lg"
					color="black"
				>
					取消
				</Button>
			</Stack>
		</Stack>
	);
}
